import type { SortKey } from '@optionway/models';

interface SortOptionsStore {
  sortBy: SortKey;
}

export const useSortOptionsStore = defineStore('sort-options', {
  state: (): SortOptionsStore => ({
    sortBy: 'price',
  }),
});
